// extracted by mini-css-extract-plugin
module.exports = {"pen":"PenColorIcon_pen__NsRxr","svg":"PenColorIcon_svg__3qa04"};